import React from 'react'

const CommonDivider = () => {
    return (
        <div className='divider-class'></div>
    )
}

export default CommonDivider